import { transport, BASE_PATH } from "@/src/config/apiConfig.js";

export default {
  async getCustomEvents() {
    try {
      const res = await transport.get(
        `${BASE_PATH}/api/custom-events`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching custom events: ",
        error,
      );
      throw error;
    }
  },

  async createCustomEvent(params) {
    try {
      const res = await transport.post(
        `${BASE_PATH}/api/custom-events`,
        params,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating custom event: ",
        error,
      );
      throw error;
    }
  },

  async updateCustomEvent(customEventId, params) {
    try {
      const res = await transport.put(
        `${BASE_PATH}/api/custom-events/${customEventId}`,
        params,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating custom event: ",
        error,
      );
      throw error;
    }
  },

  async deleteCustomEvent(id) {
    try {
      const res = await transport.delete(
        `${BASE_PATH}/api/custom-events/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while deleting custom event: ",
        error,
      );
      throw error;
    }
  },

  async fetchWebhookTriggers() {
    try {
      const res = await transport.get(`${BASE_PATH}/api/webhook-triggers`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching webhook triggers: ",
        error,
      );
      throw error;
    }
  },

  async createWebhookTrigger(payload) {
    try {
      const res = await transport.post(
        `${BASE_PATH}/api/webhook-triggers`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while creating webhook trigger: ",
        error,
      );
      throw error;
    }
  },

  async fetchWebhookTriggerFields(webhookId, eventId = "") {
    try {
      const params = eventId ? { event_id: eventId } : {};
      const res = await transport.get(
        `${BASE_PATH}/api/webhook-triggers/${webhookId}/fields`,
        { params }
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching webhook trigger fields: ",
        error,
      );
      throw error;
    }
  },

  async deleteWebhookTrigger(webhookId) {
    try {
      const res = await transport.delete(
        `${BASE_PATH}/api/webhook-triggers/${webhookId}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while deleting webhook trigger: ",
        error,
      );
      throw error;
    }
  },

  async saveWebhookTriggerCredentials(webhookTriggerId, payload) {
    try {
      const res = await transport.post(
        `${BASE_PATH}/api/webhook-triggers/${webhookTriggerId}/meta/credentials`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while saving webhook trigger credentials: ",
        error,
      );
      throw error;
    }
  },

  async fetchMetaPages(webhookTriggerId) {
    try {
      const res = await transport.get(
        `${BASE_PATH}/api/webhook-triggers/${webhookTriggerId}/meta/pages`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching Meta pages: ",
        error,
      );
      throw error;
    }
  },

  async fetchMetaForms(webhookTriggerId, pageId) {
    try {
      const res = await transport.get(
        `${BASE_PATH}/api/webhook-triggers/${webhookTriggerId}/meta/pages/${pageId}/forms`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching Meta forms: ",
        error,
      );
      throw error;
    }
  },
};
